"use client";

import { cva, type VariantProps } from "cva";
import { cn } from "../../lib/utils";
import { BaseSeparator, type BaseSeparatorProps } from "./separator";

// TODO: remove all the generic colors, that was for testing since our tenant hexes are not setup yet
const conEdisonSeparatorVariants = cva({
  base: "bg-tenant-con-edison-website-gray bg-orange-500",
  variants: {
    variant: {
      default: "",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface ConEdisonSeparatorProps
  extends Omit<BaseSeparatorProps, "variant"> {
  variant?: VariantProps<typeof conEdisonSeparatorVariants>["variant"];
  className?: string;
}

export default function ConEdisonSeparator({
  className,
  variant,
  ...props
}: ConEdisonSeparatorProps) {
  return (
    <BaseSeparator
      {...props}
      className={cn(
        conEdisonSeparatorVariants({
          variant,
          className,
        }),
        className,
      )}
    />
  );
}
